import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Plus, Sparkles } from "lucide-react";

export const CartAddons = () => {
  const { items, addItem } = useCart();
  const [addons, setAddons] = useState([]);

  useEffect(() => { api.get("/addons").then((r) => setAddons(r.data)).catch(() => {}); }, []);

  if (addons.length === 0) return null;
  const inCart = (id) => items.some((i) => i.id === id);

  return (
    <div className="bg-white rounded-xl border border-[#E5DFD5] p-5" data-testid="cart-addons">
      <h3 className="font-heading text-xl text-[#3A3632] flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#D9CBA0]" /> Enhance your gift</h3>
      <p className="text-sm text-[#8A8175] mt-1">A small touch can mean so much. Add a little extra care:</p>
      <div className="grid sm:grid-cols-2 gap-2 mt-4">
        {addons.map((a) => (
          <div key={a.id} className="flex items-center gap-3 border border-[#E5DFD5] rounded-xl p-2.5" data-testid={`cart-addon-${a.slug}`}>
            <img src={a.image} alt={a.name} className="h-11 w-11 rounded-lg object-cover bg-[#F2EFEB]" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[#3A3632] truncate">{a.name}</div>
              <div className="text-xs text-[#8E9A86] font-semibold">+{money(a.price)}</div>
            </div>
            <button onClick={() => addItem(a, 1)} disabled={inCart(a.id)} data-testid={`cart-addon-add-${a.slug}`}
              className="text-xs inline-flex items-center gap-1 border border-[#8E9A86] text-[#8E9A86] rounded-full px-3 py-1.5 font-medium hover:bg-[#8E9A86] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              {inCart(a.id) ? "Added" : <><Plus className="h-3 w-3" /> Add</>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
